import { render } from "./BalanceChart.vue?vue&type=template&id=08f55686"
import script from "./BalanceChart.vue?vue&type=script&lang=js"
export * from "./BalanceChart.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__